import { useUserStore } from '../..';
import { isNull } from '@core/tools';
import { type ITableOperator } from '@vue3/components';
import { ref, watch } from 'vue';

/** 根据权限过滤按钮(用于el-table row中的按钮) */
export function useTblPermissionButtons(items: ITableOperator[]) {
  const { state } = useUserStore();

  const buttons = ref<ITableOperator[]>([]);

  function getAvailableOperators(list: ITableOperator[]) {
    if (__MOCK_PROD__ || __ENABLE_DEV_MOCK__) {
      return list;
    }
    return list.filter((v) => {
      if (isNull(v.code) || state.permissions.includes(v.code)) {
        if (v.systemType) {
          
          return v.systemType.includes(state.identity.systemType);
        }
        return true;
      }
    });
  }

  watch(
    () => state.permissions,
    () => {
      const btns = getAvailableOperators(items);

      buttons.value = btns;
    },
    { immediate: true },
  );

  return { buttons };
}
